import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Select } from 'antd';

const FormItem = Form.Item;
const createForm = Form.create;
const Option = Select.Option;

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    formPrefixCls: 'sys-basic',
    prefixCls: 'sys-user-changeRole',
  }
  componentDidMount() {
    const { location: { query }, sysStore: { init, getSysPersons } } = this.props;
    init();
    getSysPersons({ mid: query.mid });
  }
  onSubmit = () => {
    const { location: { query }, sysStore: { update }, form: { getFieldValue } } = this.props;
    update({ mid: query.mid, role: getFieldValue('role') });
  }
  render() {
    const { formPrefixCls, form, prefixCls, sysStore: { userList, routing, formLoading } } = this.props;
    const formItemLayout = {
      labelCol: { span: 8, offset: 6 },
      wrapperCol: { span: 8 },
    };
    const { getFieldProps } = form;
    const userDetail = toJS(userList)[0] || {};
    return (
      <div className={`${formPrefixCls}`}>
        <Form>
          <FormItem className={`${formPrefixCls}-row`} label="用户名：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('name', {
                initialValue: userDetail.m_name,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="公司：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('comname', {
                initialValue: userDetail.m_Comname,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="分部：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('branch', {
                initialValue: userDetail.m_branch,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="部门：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('dep', {
                initialValue: userDetail.m_department,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="岗位：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('control', {
                initialValue: userDetail.m_position,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="登录账号：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Input disabled {...getFieldProps('account', {
                initialValue: userDetail.m_user,
              })} />
            </span>
          </FormItem>
          <FormItem className={`${formPrefixCls}-row`} label="角色：" {...formItemLayout}>
            <span className={`${formPrefixCls}-row-wrapper`}>
              <Select {...getFieldProps("role", {
                initialValue: userDetail.r_id,
              })}>
								<Option value="40">会员</Option>
								<Option value="45">开发者</Option>
								<Option value="70">公司管理员</Option>
								<Option value="80">管理员</Option>
							</Select>
            </span>
          </FormItem>
          <Row className={`${formPrefixCls}-row`}>
            <Col offset={6} span={18}>
              <div className={`${prefixCls}-btn`}>
                <Button type="primary" onClick={this.onSubmit} loading={formLoading}>提交</Button>
                <Button onClick={() => routing.go(-1)}>返回</Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/user/ChangeRole.js